/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ list: NonNullable<unknown> }} Serve_AgentsInputs */

const en_serve_agents = /** @type {(inputs: Serve_AgentsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI helpers found: ${i?.list}`)
};

const id_serve_agents = /** @type {(inputs: Serve_AgentsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Asisten AI yang ditemukan: ${i?.list}`)
};

/**
* | output |
* | --- |
* | "AI helpers found: {list}" |
*
* @param {Serve_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_agents = /** @type {((inputs: Serve_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_agents(inputs)
	return en_serve_agents(inputs)
});